import * as React from 'react';
import { Typography, TypographyPropsVariantOverrides } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';

export interface DynamicTextProps {
  text: string;
}

export const DynamicText: React.FC<DynamicTextProps> = ({ text }) => {
  const parts = text.split(/(\*\*.*?\*\*)/g);

  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return (
        <Typography key={index} variant="h1" component="h3">
          {part.replace(/\*\*/g, '')}
        </Typography>
      );
    } else {
      return (
        <Typography key={index} variant="work-sans-h1" component="h3">
          {part}
        </Typography>
      );
    }
  });
};
